import { colors, mixin } from "@hubrise/react-components"
import styled from "styled-components"

import Table from "shared/components/Table"
import { IVariant } from "shared/hubrise/models"

export const Intro = styled.div`
  margin-bottom: 1rem;
`

export const StyledTable = styled(Table<IVariant>)`
  //width: 100%;
`

export const RefCode = styled.div`
  color: ${colors.textLighter};
`

export const Show = styled.div`
  text-decoration: underline;
  ${mixin.clickable};

  :hover {
    text-decoration: none;
  }
`
